import $ from 'jquery';
import { generateIconElement, ICON } from "../../Icons/Icons";
import { FEATURE_NAMES, UNLIMITED } from "../../MVC/rolesHelper";
import AlertNotification from "../Notifications/AlertNotification";

/**
 * UserPasswordChangeModal - A component for handling password change
 */
class NewSpaceSelection {
  /**
   * Get the modal template
   * @returns {string} HTML template
   */
  modalTemplate() {

    /// add this
    // <div class="modal user_profile_holder userEditProfileModal light-theme" id="userProfileModal">
    //   <div class="modal-background"></div>

    //   <div class="modal-content non-fullscreen-mobile">
    return `
<div class="modal newSpaceSelectionModal light-theme" id="newSpaceSelectionModal">
  <div class="modal-background"></div>
  <div class="modal-content non-fullscreen-mobile">
    <!-- Space Select Pricing Cards -->
    <div class="space_select-cards-container">
      <div class="space_select-card">
        <div class="space_select-card__price-row">
          <span class="space_select-card__price">Free</span>
        </div>
        <div class="space_select-card__title">Public Space</div>
        <ul class="space_select-card__features">
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Preview Image</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Unlimited Rooms</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Space Contributors</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Space Location</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Enable Guided Tours</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Info Element</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Screenshare</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Image Link</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Image Gallery</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Video Element</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Ambient Sound</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Lockable Rooms</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Chess Game</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>10 Max Number of Chairs</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Embedded Website (Preview with CTA)</li>
        </ul>
        
        <div class="space_select-card__actions">
          <button class="space_select-card__cta" id="create_public_space">Try for free</button>
          <button class="space_select-card__close">Close</button>
        </div>
      </div>
      <div class="space_select-card space_select-card--premium">
        <div class="space_select-card__price-row">
          <span class="space_select-card__price">12€</span>
        </div>
        <div class="space_select-card__title">Premium Space</div>
        <ul class="space_select-card__features">
          <li class="space_select-card__feature">All from Free Space</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Embedded Website (Domain can be restricted)</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Public Rooms</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Paid Rooms</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Welcome Screen</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>YouTube Video</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Hide from Space Browser (selectable)</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Disable Guest Restrictions (selectable)</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Translated Subtitles for Seats (everyone gets translations)</li>
          <li class="space_select-card__feature"><span class="space_select-card__icon">✅</span>Translated Subtitles for Tours (everyone gets translations)</li>
        </ul>
        <div class="space_select-card__actions">
          <button class="space_select-card__cta space_select-card__cta_not_available" id="not_available_premium">Not available</button>
          <button class="space_select-card__cta space_select-card__cta_available" id="create_premium">Create Premium</button>
          <button class="space_select-card__close">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
`;
  }

  miniVersionTemplate() {
    return `
<div class="confirm-modal confirm-modal--light-theme middle space-select-modal">
  <div class="confirm-dialog">
    ${generateIconElement(ICON.CLOSE, { classes: 'confirm-close' }).prop('outerHTML')}
    
    <div class="space-select-modal__title" data-lang="space-select-type-select-question">
      ${$trans('space-select-type-select-question')}
    </div>
    
    <div class="confirm-footer my-5">
      <button id="mini_create_public_space" class="buttn primary" data-lang="public-space-text">
        ${$trans('public-space-text')}
      </button>
      
      <button id="mini_create_premium_space" class="buttn primary" data-lang="premium-space-text">
        ${$trans('premium-space-text')}
      </button>
    </div>
    
    <div class="space-select-modal__differences-question" data-lang="space-select-differences-question">
      ${$trans('space-select-differences-question')}
    <div
  </div>
</div>
    `
  }

  premiumSpaceNotAvailableModal() {
    return `
<div class="confirm-modal confirm-modal--light-theme middle space-select-modal">
  <div class="confirm-dialog">
    ${generateIconElement(ICON.CLOSE, { classes: 'confirm-close' }).prop('outerHTML')}
    
    <div class="space-select-modal__title space-select-modal__upgrade-plan-message" data-lang="space-select-upgrade-required">
      ${$trans('space-select-upgrade-required')}
    </div>
    <div class="space-select-modal__title space-select-modal__out-of-quota-message" data-lang="space-select-out-of-quota">
      ${$trans('space-select-out-of-quota')}
    </div>
    
    <div class="confirm-footer my-5">
      <button id="cancel_premium_space" class="buttn secondary" data-lang="cancel-text">
        ${$trans('cancel-text')}
      </button>
      
      <button id="go_to_subscription_page" class="buttn primary" data-lang="go-to-subscription-page">
        ${$trans('go-to-subscription-page')}
      </button>
    </div>
    
    <div class="space-select-modal__differences-question" data-lang="space-select-differences-question">
      ${$trans('space-select-differences-question')}
    <div
  </div>
</div>
    `
  }

  ///constructor
  constructor({ model }) {
    this.model = model;
    this.alertNotification = new AlertNotification({})
    this.createPremiumFeature = window.subscriptionPlan?.plan?.features?.[FEATURE_NAMES.CREATE_PREMIUM_SPACES]

    this.render()
    this.addEventListeners()
  }
  ///render
  render() {
    this.$modal = $(this.modalTemplate());
    $('body').append(this.$modal);

    this.$miniVersionModal = $(this.miniVersionTemplate())
    $('body').append(this.$miniVersionModal)

    this.$premiumSpaceNotAvailableModal = $(this.premiumSpaceNotAvailableModal())
    $('body').append(this.$premiumSpaceNotAvailableModal)

    this.$elements = {
      // full version
      $createPublicSpace: this.$modal.find('#create_public_space'),
      $createPremiumSpace: this.$modal.find('#create_premium'),
      $notAvailable: this.$modal.find('#not_available_premium'),
      $close: this.$modal.find('.space_select-card__close'),

      // mini version
      $miniCreatePublicSpace: this.$miniVersionModal.find('#mini_create_public_space'),
      $miniCreatePremiumSpace: this.$miniVersionModal.find('#mini_create_premium_space'),

      // premium space not available modal
      $upgradePlanMessage: this.$premiumSpaceNotAvailableModal.find('.space-select-modal__upgrade-plan-message'),
      $outOfQuotaMessage: this.$premiumSpaceNotAvailableModal.find('.space-select-modal__out-of-quota-message'),
      $cancelPremiumSpace: this.$premiumSpaceNotAvailableModal.find('#cancel_premium_space'),
      $goToSubscriptionPage: this.$premiumSpaceNotAvailableModal.find('#go_to_subscription_page')
    }
  }

  addEventListeners() {
    const draftUrl = window.location.origin + '/worlds/draft';
    const subscriptionUrl = '/myprofile/subscriptions';

    this.$elements.$createPublicSpace.on('click', () => {
      window.location.href = draftUrl
    })

    this.$elements.$miniCreatePublicSpace.on('click', () => {
      window.location.href = draftUrl
    })

    const checkPlanAndCreatePremiumSpace = () => {
      const maximumPremiumSpaces = window.subscriptionPlan?.customer.total_premium_spaces || this.createPremiumFeature?.value || 0
      const usedPremiumSpaces = window.subscriptionPlan?.customer.used_premium_spaces || 0
      if (!this.createPremiumFeature?.availability) {
        this.showUpgradeModal()
      } else if (maximumPremiumSpaces !== UNLIMITED && maximumPremiumSpaces <= usedPremiumSpaces) {
        this.showOutOfQuotaModal()
      } else {
        window.location.href = draftUrl
      }
    }
    this.$elements.$createPremiumSpace.on('click', () => {
      checkPlanAndCreatePremiumSpace()
    })
    this.$elements.$miniCreatePremiumSpace.on('click', () => {
      checkPlanAndCreatePremiumSpace()
    })

    this.$elements.$close.on('click', () => {
      this.hide()
    })

    this.$modal.find('.space_select-card__cta_not_available').on('click', async () => {
      if (!this.createPremiumFeature?.availability) {
        this.alertNotification.createNotification({
          ...this.alertNotification.defaults,
          classType: 'error',
          text: 'This action is not available on your current plan. Please upgrade to access this feature.'
        })
        return;
      }

      window.location.href = draftUrl;
    })

    this.$miniVersionModal.on('click', '.confirm-close', () => {
      this.hideMiniVersion()
    })
    this.$premiumSpaceNotAvailableModal.on('click', '.confirm-close', () => {
      this.hideNotAvailableModal()
    })

    this.$elements.$cancelPremiumSpace.on('click', () => {
      this.hideNotAvailableModal()
    })
    this.$elements.$goToSubscriptionPage.on('click', () => {
      window.location.href = subscriptionUrl
    })
  }

  show({ showActions = true } = {}) {
    this.$elements.$notAvailable.hide()
    this.$elements.$createPremiumSpace.hide()
    this.$elements.$createPublicSpace.hide()

    if (window.isGuest) {
      // No actions needed to be shown
    } else if (!this.createPremiumFeature?.availability) {
      if (showActions) {
        this.$elements.$notAvailable.show()
        this.$elements.$createPublicSpace.show()
      }
    } else {
      if (showActions) {
        this.$elements.$createPublicSpace.show()
        this.$elements.$createPremiumSpace.show()
      }
    }

    this.$modal.addClass('is-active');
  }

  hide() {
    this.$modal.removeClass('is-active');
  }

  showMiniVersion() {
    this.$miniVersionModal.addClass('visible').show()
  }

  hideMiniVersion() {
    this.$miniVersionModal.removeClass('visible').hide()
  }

  showUpgradeModal() {
    this.$elements.$outOfQuotaMessage.hide()
    this.$elements.$upgradePlanMessage.show()
    this.$premiumSpaceNotAvailableModal.addClass('visible').show()
  }

  showOutOfQuotaModal() {
    this.$elements.$outOfQuotaMessage.show()
    this.$elements.$upgradePlanMessage.hide()
    this.$premiumSpaceNotAvailableModal.addClass('visible').show()
  }

  hideNotAvailableModal() {
    this.$premiumSpaceNotAvailableModal.removeClass('visible').hide()
  }
}

export default NewSpaceSelection;
